<template>
<div></div>
</template>

<script>
export default {
  name: "Login",
  data: () => ({
      loginSnackbarShown: false,
      loginSnackbarText: "",
  }),
  computed: {
  },
  methods: {
    isLoggedInMSAL() {
      return this.$msal.getAllAccounts().length !== 0;
    },
    getAccessTokenMSAL() {
      return this.$msal.getSilentToken(this.$msal.getAllAccounts()[0], [""]).then((rep) => {
        this.token = rep.accessToken
      }).catch(() => {});
    }
  },
  watch: {
      "$i18n.locale": function () {
      }
  },
  created () {
    this.$msal.authenticateRedirect().then(() => {
      this.$router.push({path: '/account'}).catch(() => {});
    });
  }
}
</script>
